import {VideoFormatEnum} from "../enums/videoFormat.enum";

export const ALL_VIDEO_4k = [VideoFormatEnum.VIDEO_4K, VideoFormatEnum.VIDEO_C4K];
export const ALL_VIDEO_6k = [VideoFormatEnum.VIDEO_6K, VideoFormatEnum.VIDEO_6_2K, VideoFormatEnum.VIDEO_C6K];
